import React from 'react';

const FormattedSuggestion = ({ text }) => {
    // Função para converter markdown simples (apenas negrito com *) em JSX
    const parseInlineFormatting = (line) => {
        const parts = line.split(/(\*.*?\*)/g); // Separa o texto por *palavras em negrito*
        return parts.filter(part => part).map((part, i) => {
            if (part.startsWith('*') && part.endsWith('*')) {
                return <strong key={i} className="font-semibold text-indigo-300">{part.slice(1, -1)}</strong>;
            }
            return part;
        });
    };

    // Divide o texto em linhas para processar cada uma
    const lines = text.split('\n').filter(line => line.trim() !== '');

    return (
        <div className="font-sans text-base leading-relaxed text-gray-300">
            {lines.map((line, index) => {
                // Remove os asteriscos duplos (**) que o Gemini às vezes usa para títulos
                const cleanLine = line.replace(/\*\*/g, '');

                // Renderiza títulos (ex: "Primeiro Passo:", "Pontos de Atenção:")
                if (cleanLine.startsWith('Primeiro Passo:') || cleanLine.startsWith('Pontos de Atenção:') || cleanLine.startsWith('Fase')) {
                    return (
                        <h3 key={index} className="text-lg font-bold text-white mt-6 mb-3 border-b border-white/10 pb-2">
                            {cleanLine}
                        </h3>
                    );
                }

                // Renderiza itens de lista (linhas que começam com * ou -)
                if (cleanLine.trim().startsWith('* ') || cleanLine.trim().startsWith('- ')) {
                    const listItemText = cleanLine.trim().substring(1).trim();
                    return (
                        <div key={index} className="flex items-start my-3 pl-2">
                            <span className="text-indigo-400 mr-3 mt-1">◆</span>
                            <p className="flex-1">{parseInlineFormatting(listItemText)}</p>
                        </div>
                    );
                }

                // Renderiza parágrafos normais
                return (
                    <p key={index} className="my-3">
                        {parseInlineFormatting(cleanLine)}
                    </p>
                );
            })}
        </div>
    );
};

export default FormattedSuggestion;